import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs/operators';
import { selectUser } from '@core/modules/user/features/user.slice';
import { USER_PROMOTES_ROUTES } from '@core/constants/app-routes';
import { RedirectAfterLoginService } from '@core/services/redirect-after-login.service';

@Component({
    selector: 'app-social-media-detail-public',
    templateUrl: './social-media-detail-public.component.html',
    styleUrls: ['./social-media-detail-public.component.scss'],
    standalone: false
})
export class SocialMediaDetailPublicComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private destroyRef: DestroyRef,
    private store: Store,
    private redirectAfterLoginService: RedirectAfterLoginService
  ) {}

  ngOnInit(): void {
    forkJoin([
      this.activatedRoute.data.pipe(first()),
      this.activatedRoute.params.pipe(first()),
      this.store.select(selectUser).pipe(first())
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([data, params, user]) => {
        const promoteViewPath = USER_PROMOTES_ROUTES.PROMOTE_VIEW(params.id);

        if (!user) {
          this.router.navigateByUrl(this.redirectAfterLoginService.loginUrlTree(promoteViewPath));

          return;
        }

        data.roles?.includes(user!.roleId) && this.router.navigateByUrl(promoteViewPath);
      });
  }
}
